/* global Pegasus:true */
Em.View.reopen({
  rerender: function(){
    if ( this.get('state') !== 'inDOM' ) { return; }
    this._super();
  }
});

window.Pegasus = Ember.Application.create({
  version: 6668406280223280,
  defaultEmailName: '',
  options: {},
  status: 'loading',
  lastLeaf: null,
  loaded: false,
  nextCopy: 'Continue',
  loadedTemplate: function() {
    return this.lookupController('template').get('content');
  },
  lookupStore: function() {
    // console.log('TODO: remove reference to Pegasus.lookupStore()');
    return this.__container__.lookup('store:main');
  },

  // TODO~ temporary helper - should be removed after refactor
  // it's no longer appropriate to reference Pegasus.router
  lookupRouter: function() {
    // console.log('TODO: remove reference to Pegasus.lookupRouter()');
    return this.__container__.lookup('router:main');
  },

  // TODO~ temporary helper - should be removed after refactor
  // oauth_complete.html.haml needs to call didCompleteOauth on SocialAccounts controller
  lookupController: function(controllerName, options) {
    // console.log('TODO: remove reference to Pegasus.lookupController()');
    return this.__container__.lookup('controller:' + controllerName, options);
  },

  // TODO~ seems bad to refer to default container directly, but
  // probably the thing to do is refactor the NotificationView API to
  // send events to the router rather than create views manually.
  lookupContainer: function(){
    // console.log("TODO: remove reference to Pegasus.lookupContainer()");
    return this.__container__;
  },

  setup: function(options){
    Pegasus.host = function(){
      var host = window.location.protocol+'//'+window.location.hostname+(window.location.port ? ':'+window.location.port: '');
      return host;
    };

    Pegasus.handoffHost = function(){
      return Pegasus.host() + "/users/sign_up?proctor=editor-wrapper";
    };

    Pegasus.set('options', options);

    Pegasus.stateMachine = Pegasus.StateMachine.create({
      enableLogging: true
    });
  },
  ready: function(){
    var commandManager = Pegasus.CommandManager.create({
      controller: Pegasus.lookupController('historyOperations')
    });

    Pegasus.IOManager.buildModelForContext( window.editorDocumentType );

    Pegasus.lookupController('historyOperations').set('content', commandManager);

    var frameCommManager = Pegasus.lookupController('frameCommManager');

    window.addEventListener( 'message', frameCommManager.listen.bind(frameCommManager) );
    frameCommManager.say(window.parent, {
      method: 'requestEditorContext',
      payload: {}
    });

    this.preload();
  },
  showTemplate: function(loaded){
    this.lookupRouter().transitionTo( 'template', loaded );
  },
  teardown: function(){
    Pegasus.lookupController('historyOperations').set('content', []);
    Pegasus.set('options', null);
  },
  preload: function(callback){
    if ( callback ) {
      callback();
    }
    return;
    // create a dummy element off the page on the X axis
    // and load CKeditor into it and then immediately.
    // Then we self-destruct.


    //if( CKEDITOR && CKEDITOR.instances && CKEDITOR.instances.ckloader ){
      //CKEDITOR.instances.ckloader.destroy(true);
    //}
    // The initial load is expensive so do it
    // before the user tries.
    //preloadCK();
  }
});

(function(){
  var featherLoaded = false;

  window.imageEditor = {};
  imageEditor.launch = function(params){
    var frameCommManager = Pegasus.lookupController('frameCommManager');
    var image = $('#'+params.image).attr('src');

    frameCommManager.launchImageEditor(image);
  };

  imageEditor.close = function(){
    $('.filerobot-image-editor, .photoeditorsdk').remove();
  };

  window.featherEditor = window.imageEditor;

  Pegasus.reopen({
    loadTuiEditor: function(options){
      import( /* webpackChunkName: "pegasus_resizer" */ 'resize_tool/index.js').then(function(resizer){
        resizer.launch(options);
      });
    },
    loadImageEditor: function(callback){
      var $frame = $('<iframe class="filerobot-image-editor">');
      var frame = $frame[0];
      frame.src = '/pegasus/assets/filerobot/index.html';
      frame.onload = function(){
        Em.run( Pegasus.lookupController('frameCommManager'), 'set', 'editorFrame', this.contentWindow );
        if (callback) {
          callback();
        }
      };
      $frame.appendTo('body');
      window.editorFrame = frame;
    },
    loadFeatherEditor: function(callback){
      return this.loadImageEditor(callback);
    }
  });
})();

Pegasus.deferReadiness();
